export default __webpack_public_path__ + "static/media/layersControl.de703cbc.svg";